class FormatGraphDataService {
    static sortByValue = data => [...data].sort((a, b) => ((a.values < b.values) ? 1 : -1));

    static sortByName = (data, first) =>
    // eslint-disable-next-line no-nested-ternary
        data.sort((x, y) => (x.name === first ? -1 : y.name === first ? 1 : 0));

    static addCommas = x =>
        /* const { lang } = document.documentElement;

        if (lang) {
            return x.toLocaleString(lang);
        } */

        x.toLocaleString('nl')
    ;

    static twoDecimalPlaces = (x) => {
        let number = Number.parseFloat(x).toFixed(2);
        number = number.replace('.', ',');

        return number;
    }

    static formatMultipleValues = data => data.map((item) => {
        const stackedItem = {};

        stackedItem.name = item.name;

        item.values.forEach((itemValues, index) => {
            stackedItem[`values${index}`] = itemValues.values;
        });

        return stackedItem;
    });
}

export default FormatGraphDataService;
